// extracted by mini-css-extract-plugin
module.exports = {"CustomAccordionContainer":"CustomAccordion_CustomAccordionContainer__2qyZ9","Trigger":"CustomAccordion_Trigger__KZQ-a","Count":"CustomAccordion_Count__14VSf"};